import classnames from 'classnames'
import { useTranslation } from 'next-i18next'
import React, { useCallback, useRef, useState } from 'react'

import { OptionProp } from '../OptionSelector.constant'

import styles from './inputOption.module.scss'

const REGEX_PATTERN = /^[ A-Za-z0-9_@.\/#&$%+-=!?*,>'"^()]*$/

const InputOption = ({ onChange, maxCharacterLimit }: Pick<OptionProp, 'onChange' | 'maxCharacterLimit'>) => {
  const { t } = useTranslation('common')
  const [inputText, setInputText] = useState('')
  const [showError, setErrorText] = useState(false)
  const timerRef = useRef<number>()
  const handleChange = useCallback(e => {
    const value = e.target.value
    const isValidText = REGEX_PATTERN.test(value)
    if (isValidText && value.length <= maxCharacterLimit) {
      setInputText(value)
      onChange?.(value.trim())
    } else if (value.length > maxCharacterLimit) {
      showErrorAndHide()
    }
  }, [])

  const showErrorAndHide = () => {
    setErrorText(true)
    clearTimeout(timerRef.current)
    timerRef.current = window.setTimeout(() => {
      setErrorText(false)
    }, 2500)
  }

  return (
    <div className={styles.inputOptionWrapper}>
      <input
        className={classnames(styles.option)}
        onChange={e => {
          handleChange(e)
        }}
        placeholder={t('type_here_var1_character_max', { var1: maxCharacterLimit })}
        value={inputText}
        // onBlur={handleOnblur}
      />
      {showError ? (
        <div className={styles.errorMsg}>
          {maxCharacterLimit} {t('characters_max')}
        </div>
      ) : (
        ''
      )}
    </div>
  )
}

export default InputOption
